import BoxWithDimensionsProvider from '@contexts/box-with-dimensions-provider'
import Iframe from '@ui/iframe'
import React, { type FC } from 'react'
import ReactPlayer from 'react-player'

import { ErrorBoundary } from '../error-boundary'
import MediaPlayer from './media-player'

type Props = {
  url: string
  alt?: string
  title?: string
}

const isImageUrl = (url: string) =>
  Boolean(url.match(/\w+\.(jpg|jpeg|gif|png|tiff|bmp|svg)$/gi))

const Media: FC<Props> = ({ url, alt, title }) => {
  let media = null

  if (isImageUrl(url)) {
    const isSvgImage = String(url).endsWith('.svg')

    media = (
      <div className="flex justify-center p-2">
        <img
          alt={alt}
          src={url}
          title={title}
          style={
            isSvgImage
              ? {
                  width: '100%',
                  height: 'auto',
                  minWidth: '100%',
                  minHeight: '100px',
                }
              : { maxWidth: '100%' }
          }
        />
      </div>
    )
  } else {
    const isPlayableVideo = ReactPlayer.canPlay(url)
    media = (
      <div className="m-auto block w-full p-2">
        {isPlayableVideo ? (
          <BoxWithDimensionsProvider>
            <MediaPlayer options={{}} url={url} />
          </BoxWithDimensionsProvider>
        ) : (
          <Iframe title={title || alt || url} url={url} />
        )}
      </div>
    )
  }

  return <ErrorBoundary>{media}</ErrorBoundary>
}

export default Media
